/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiScreeningMatchProvider {
    DOW_JONES = 'DOW_JONES',
    SALV = 'SALV',
    OTHER = 'OTHER'
}


export function instanceOfApiScreeningMatchProvider(value: any): boolean {
    for (const key in ApiScreeningMatchProvider) {
        if (Object.prototype.hasOwnProperty.call(ApiScreeningMatchProvider, key)) {
            if (ApiScreeningMatchProvider[key as keyof typeof ApiScreeningMatchProvider] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApiScreeningMatchProviderFromJSON(json: any): ApiScreeningMatchProvider {
    return ApiScreeningMatchProviderFromJSONTyped(json, false);
}

export function ApiScreeningMatchProviderFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiScreeningMatchProvider {
    return json as ApiScreeningMatchProvider;
}

export function ApiScreeningMatchProviderToJSON(value?: ApiScreeningMatchProvider | null): any {
    return value as any;
}

export function ApiScreeningMatchProviderToJSONTyped(value: any, ignoreDiscriminator: boolean): ApiScreeningMatchProvider {
    return value as ApiScreeningMatchProvider;
}

